function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "hackathon thin"
}, React.createElement("g", {
  id: "hexagon"
}, React.createElement("path", {
  id: "Vector",
  d: "M194.248 56.2L97.6021 0.400004L0.95401 56.2L0.95401 167.8L97.6021 223.6L194.25 167.8V56.2H194.248ZM3.43401 166.369L3.43401 57.631L97.6021 3.2644L191.768 57.631V166.369L97.6021 220.736L3.43401 166.369Z",
  fill: "currentColor"
})), React.createElement("g", {
  id: "hackathon"
}, React.createElement("path", {
  id: "Vector_2",
  d: "M74.7356 136.858V146.441H81.125H109.875H116.264V136.858H74.7356Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_3",
  d: "M90.7079 122.483C90.7079 121.599 89.9938 120.885 89.1106 120.885C88.4056 120.885 87.826 121.348 87.6144 121.982L87.5949 121.977L84.7647 130.468H76.3329C75.4497 130.468 74.7356 131.182 74.7356 132.066C74.7356 132.949 75.4497 133.663 76.3329 133.663H87.067L90.6251 122.989L90.6056 122.982C90.6619 122.823 90.7079 122.66 90.7079 122.483Z",
  fill: "currentColor"
}), React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  id: "Vector_4",
  d: "M79.5276 120.885H65.7679L61.7394 109.864L61.7176 109.872C61.107 107.929 59.3129 106.509 57.167 106.509C56.3965 106.509 55.6778 106.709 55.0326 107.032L55.0246 107.016C44.0455 112.505 38 124.806 38 141.65C38 144.296 40.1447 146.441 42.792 146.441H57.167V162.413C57.167 165.06 59.3118 167.205 61.9591 167.205C64.6064 167.205 66.75 165.059 66.75 162.413V141.65C66.75 139.002 64.6052 136.858 61.9579 136.858H47.7865C48.3684 129.97 50.4016 122.54 55.7939 117.933L60.6987 125.508L60.7102 125.502C61.2357 126.549 62.3064 127.275 63.5564 127.275H79.5288C81.2929 127.275 82.7223 125.844 82.7223 124.08C82.7223 122.316 81.2917 120.885 79.5276 120.885Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_5",
  d: "M69.9447 110.503C73.9142 110.503 77.1322 107.285 77.1322 103.316C77.1322 99.346 73.9142 96.128 69.9447 96.128C65.9752 96.128 62.7572 99.346 62.7572 103.316C62.7572 107.285 65.9752 110.503 69.9447 110.503Z",
  fill: "currentColor"
})), React.createElement("path", {
  id: "Vector_6",
  d: "M114.667 130.468H106.234L103.404 121.977L103.386 121.982C103.173 121.348 102.594 120.885 101.888 120.885C101.005 120.885 100.291 121.599 100.291 122.483C100.291 122.66 100.337 122.823 100.392 122.982L100.373 122.989L103.931 133.663H114.666C115.549 133.663 116.263 132.949 116.263 132.066C116.263 131.182 115.55 130.468 114.667 130.468Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_7",
  d: "M121.056 110.503C125.026 110.503 128.244 107.285 128.244 103.316C128.244 99.346 125.026 96.128 121.056 96.128C117.087 96.128 113.869 99.346 113.869 103.316C113.869 107.285 117.087 110.503 121.056 110.503Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_8",
  d: "M135.977 107.016L135.969 107.032C135.322 106.709 134.602 106.509 133.833 106.509C131.689 106.509 129.893 107.928 129.284 109.872L129.261 109.864L125.232 120.885H111.472C109.708 120.885 108.279 122.315 108.279 124.079C108.279 125.843 109.708 127.273 111.472 127.273H127.445C128.695 127.273 129.767 126.548 130.292 125.501L130.304 125.507L135.21 117.932C140.601 122.539 142.634 129.969 143.216 136.856H129.042C126.395 136.856 124.25 139.001 124.25 141.648V162.412C124.25 165.059 126.395 167.204 129.042 167.204C131.689 167.204 133.833 165.059 133.833 162.412V146.441H148.208C150.855 146.441 153 144.296 153 141.65C153 124.806 146.954 112.505 135.977 107.016Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_9",
  d: "M95.5 91.3371C86.2517 91.3371 78.7296 83.8138 78.7296 74.5667C78.7296 65.3195 86.2517 57.7951 95.5 57.7951C104.748 57.7951 112.27 65.3184 112.27 74.5655C112.27 83.8127 104.748 91.3371 95.5 91.3371ZM95.5 60.9898C88.0147 60.9898 81.9231 67.079 81.9231 74.5655C81.9231 82.052 88.0147 88.1424 95.5 88.1424C102.985 88.1424 109.077 82.052 109.077 74.5655C109.077 67.079 102.985 60.9898 95.5 60.9898Z",
  fill: "currentColor"
}), React.createElement("path", {
  id: "Vector_10",
  d: "M103.486 68.1773C103.486 67.2941 102.771 66.5799 101.888 66.5799C101.444 66.5799 101.046 66.7605 100.758 67.0503L97.0962 70.7107V64.9826C97.0962 64.0994 96.3821 63.3852 95.4989 63.3852C94.6157 63.3852 93.9015 64.1005 93.9015 64.9826V74.5655C93.9015 75.4487 94.6157 76.1629 95.4989 76.1629C95.9416 76.1629 96.3407 75.9823 96.6293 75.6925L103.015 69.3089C103.306 69.0191 103.486 68.6189 103.486 68.1773Z",
  fill: "currentColor"
})));

var SvgHackathonthin = function SvgHackathonthin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 195,
    height: 224,
    viewBox: "0 0 195 224",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHackathonthin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hackathon thin.cb3b05a1.svg";
export { ForwardRef as ReactComponent };